module.exports = __webpack_public_path__ + "img/imgZXGH(15).5c9cf020.png";